import axios from 'axios';
import { Vue } from 'vue-property-decorator';
import FileUploader from '@/components/FileUploader';

export default class FilePdfUploader extends FileUploader {
  constructor(locale: string = '') {
    super();
  }

  public async uploadStart(uuid: string, type: string, file: any, url: string = null) {
    this.baseUrl = !url ? `movie/${type}/${uuid}/upload` : url;
    this.file = file;

    this.chunkCount = Math.ceil(file.size / this.CHUNK_SIZE);
    this.nextChunkIndex = 0;

    const contentType = {
      extension: file.name.substring(file.name.lastIndexOf('.') + 1),
      content_type: file.type,
    };

    if (!contentType.content_type || contentType.content_type === undefined || contentType.content_type === '') {
      if (contentType.extension === 'xls') {
        contentType.content_type = 'application/vnd.ms-excel';
      } else if (contentType.extension === 'xlsx') {
        contentType.content_type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } else if (contentType.extension === 'srt') {
        contentType.content_type = 'text/srt';
      } else if (contentType.extension === 'doc') {
        contentType.content_type = 'application/msword';
      } else if (contentType.extension === 'docx') {
        contentType.content_type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      } else if (contentType.extension === 'psd') {
        contentType.content_type = 'application/x-photoshop';
      } else if (contentType.extension === 'ai') {
        contentType.content_type = '';
      } else if (contentType.extension === 'pdf') {
        contentType.content_type = '';
      }
    }

    await Vue.axios
      .post(`${this.baseUrl}/start`, contentType)
      .then((result: any) => {
        if (result.status !== 200) {
          throw new Error(`unable to create presigned url for path ${this.baseUrl}`);
        }
        this.uploadId = result.data.upload_id;
        this.uploadKey = result.data.key;

        const url = result.data.url;
        const method = result.data.method;
        const chunk = this.file;
        if (method === 'POST') {
          return axios.post(url, chunk);
        } else if (method === 'PUT') {
          return axios.put(url, chunk);
        }
      })
      .then((result: any) => {
        if (result.status !== 200) {
          throw new Error(`unable to send file for path ${this.baseUrl}`);
        }
        return this.completeUpload();
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
}
